import EventEmitter from 'eventemitter3'

export class Entity extends EventEmitter {
  constructor(client, data) {
    super()
    this.id = data.id
    this.type = data.type
    this.client = client
    this.data = data
  }
}
